

function ShowInterviewChatOrProblemStatementRow(
    { showInterviewChats=true, setShowInterviewChats}) {
  
    return (
    <div className="flex flex-col w-full  ">
    <div className="flex flex-row w-full">
      {/* Left Button */}
      <button
        className={`flex-1 p-2 m-2 rounded-lg text-white ${
          showInterviewChats ? "bg-purple-500" : "bg-gray-500"
        }`}
        onClick={() => setShowInterviewChats(true)}
      >
        Discussion
      </button>

      {/* Right Button */}
      <button
        className={`flex-1 p-2 m-2 rounded-lg text-white ${
          showInterviewChats ? "bg-gray-500" : "bg-purple-500"
        }`}
        onClick={() => setShowInterviewChats(false)}
      >
        Problem Statement
      </button>
    </div>  

      </div>
    );
  }

  export {ShowInterviewChatOrProblemStatementRow}
